import { EntityDialog, ToolButton, localText, tryFirst } from "@serenity-is/corelib";

EntityDialog.prototype['getToolbarButtons'] = (function (old) {
    return function () {

        var buttons = old.call(this) as ToolButton[];

        var applyButton = tryFirst(buttons, x => x.cssClass === "apply-changes-button");
        if (applyButton) {
            applyButton.icon = "fa-floppy-o text-purple";
            applyButton.title = localText("Controls.EntityDialog.ApplyChangesButton")
        }

        return buttons;
    };
})(EntityDialog.prototype['getToolbarButtons']);